import React,{Component} from 'react';
import * as Gen from '../../../component';
import {Progress,Button,message,Modal, Tooltip, Row, Col, Input, Alert } from 'antd';
import { LangConsumer } from 'utils/LangProvider';
import { connect } from 'react-redux';
import {getDeviceAllInfo, setQuotaInfo, getQuotaInfo, setGroupInfo, setEject, formatDevStorage, encrypt, decrypt, clearPassword, modifyPassword} from '../../../store/views/StorageSettings/action';
import Ability from '../../../ability';
import { type } from 'os';
import {PasswordCheck, LabelSwitch, LabelInput} from 'libs';
import RPC from 'api';
import WebApp from '../../../webapp';
import Slidertool from '../Slider';

const mapStateToProps = (state) => {
    let { StorageSettings:{device, deviceList, quotaInfoList}, webCaps, publicState } = state;
    return { device, deviceList, quotaInfoList,webCaps, publicState };
};

const mapDispatchToProps = dispatch => {
    return {
        getDeviceAllInfo: (data) => {dispatch(getDeviceAllInfo(data));},
        setQuotaInfo: (data) => {dispatch(setQuotaInfo(data));},
        getQuotaInfo: (data) => {dispatch(getQuotaInfo(data));},
        setGroupInfo: (data) => {dispatch(setGroupInfo(data));},
        setEject: (data) => {dispatch(setEject(data));},
        formatDevStorage: (data) => {dispatch(formatDevStorage(data));},
        encrypt: (data) => {dispatch(encrypt(data));},
        decrypt: (data) => {dispatch(decrypt(data));},
        clearPassword: (data) => {dispatch(clearPassword(data));},
        modifyPassword: (data) => {dispatch(modifyPassword(data));}
    };
};

let {Table} = Gen;
const {ColumnHeader,ListData} = Table;

// 点击加密后的弹出框
class EncryptModal extends Component {
    constructor (props) {
        super(props);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleOk () {
        var {result, newPassword} = this.refs.passwordRef.onSubmit();
        if (result) {
            this.props.onConfirm(newPassword);
            this.refs.passwordRef.clear();
        }
    }

    handleCancel = e => {
        this.props.onCancel();
        this.refs.passwordRef.clear();
    };

    render () {
        var { $t } = this.props;
        return (
            <Modal
                title = {$t('SDEncrypt.Encrypt')}
                visible = {this.props.visible}
                onOk = {this.handleOk}
                onCancel = {this.handleCancel}
            >
                <PasswordCheck ref = 'passwordRef' mode = 'normal' textAlign = {{textAlign: 'right'}}/>
            </Modal>
        );
    }
}

// 点击认证后的弹出框
class DecryptModal extends Component {
    constructor (props) {
        super(props);
        this.state = {
            password: ''
        };
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleOk () {
        var { password } = this.state;
        this.props.onConfirm(password);
    }

    handleCancel () {
        this.props.onCancel();
    }

    onInputChange (e) {
        this.setState({
            password: e.target.value
        });
    }
    render () {
        var { $t } = this.props;
        return (
            <Modal
                title = {$t('SDEncrypt.Decrypt')}
                visible = {this.props.visible}
                onOk = {this.handleOk}
                onCancel = {this.handleCancel}
            >
                <Row style = {{marginTop:'5px'}}>
                    <Col span={6} style = {{textAlign: 'right', lineHeight:'32px'}}>{$t('com.Password')}</Col>
                    <Col span={15} style = {{marginLeft: '10px'}}>
                        <Input
                            type = "password"
                            value = {this.state.password}
                            maxLength = {64}
                            onChange = {this.onInputChange.bind(this)}/>
                    </Col>
                </Row>
            </Modal>
        );
    }
}

// 点击清除密码的弹出框
class ClearPasswordModel extends Component {
    constructor (props) {
        super(props);
        this.state = {
            password: ''
        };
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleOk () {
        this.props.onConfirm(this.state.password);
        this.setState({
            password: ''
        });
    }

    handleCancel = e => {
        this.props.onCancel();
        this.setState({
            password: ''
        });
    }

    onInputChange (e) {
        this.setState({
            password: e.target.value
        });
    }

    render () {
        var { $t } = this.props;
        return (
            <Modal
                title = {$t('SDEncrypt.ClearPassword')}
                visible = {this.props.visible}
                onOk = {this.handleOk}
                onCancel = {this.handleCancel}
            >
                <Row style = {{marginTop:'5px'}}>
                    <Col span={6} style = {{textAlign: 'right', lineHeight:'32px'}}>{$t('com.Password')}</Col>
                    <Col span={15} style = {{marginLeft: '10px'}}>
                        <Input
                            type = "password"
                            value = {this.state.password}
                            maxLength = {64}
                            onChange = {this.onInputChange.bind(this)}/>
                    </Col>
                </Row>
            </Modal>
        );
    }
}

// 点击修改密码后的弹出框
class ModifyPasswordModel extends Component {
    constructor (props) {
        super(props);
        this.state = {
            password: ''
        };
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleOk () {
        var oldPassword = this.state.password;
        var {result, newPassword = ''} = this.refs.passwordRef.onSubmit();
        if (result) {
            this.props.onConfirm({
                result,
                password: newPassword,
                oldPassword
            });
            this.refs.passwordRef.clear();
        }
    }

    handleCancel = e => {
        this.props.onCancel();
        this.refs.passwordRef.clear();
    };

    onInputChange (e) {
        this.setState({
            password: e.target.value
        });
    }

    render () {
        var { $t } = this.props;
        return (
            <Modal
                title = {$t('sys.ModifyPwd')}
                visible = {this.props.visible}
                onOk = {this.handleOk}
                onCancel = {this.handleCancel}
            >
                <Row style = {{marginTop:'5px'}}>
                    <Col span={6} style = {{textAlign: 'right', lineHeight:'32px', marginLeft: '10px'}}>{$t('com.Password')}</Col>
                    <Col span={15} style = {{marginLeft: '10px'}}>
                        <Input
                            type = "password"
                            value = {this.state.password}
                            maxLength = {64}
                            onChange = {this.onInputChange.bind(this)}/>
                    </Col>
                </Row>
                <PasswordCheck ref = 'passwordRef' mode = 'normal' textAlign = {{textAlign: 'right'}}/>
            </Modal>
        );
    }
}

// 点击硬盘配额后的弹出框
class ShowQuotaInfoModal extends Component {
    constructor (props) {
        super(props);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleOk () {
        //var oldPassword = this.state.password;
        //var {result, newPassword = ''} = this.refs.passwordRef.onSubmit();
        //if (result) {
        this.props.onConfirm({
            videoPercent: this.props.videoPercent,
            EnableQuota: this.props.EnableQuota
        });
        //}
    }

    handleCancel = e => {
        this.props.onCancel();
    };

    onInputChange (e) {
        this.setState({
            password: e.target.value
        });
    }

    /**
     * 修改 netAutoAdaptEncode:网络自适应+码流平滑
     */
    changeVideoPercent = (key, val) => {
        this.props.onChangeVideoPercent(val);
    }

    changeEnableQuota = (val) => {
        this.props.onChangeEnableQuota(val);
    }

    render () {
        var { $t,
            publicState: {
                getGrid
            },
            EnableQuota,
            videoPercent,
        } = this.props;
        const multiple = {
            type: 'normal',
            multiple: 1
        };
        const multiple2 = {
            type: 'long',
            multiple: 2
        };

        return (
            <Modal
                title = {$t('sto.Setscal')}
                visible = {this.props.visible}
                onOk = {this.handleOk}
                onCancel = {this.handleCancel}
            >
                <Row className='quota-dlg-row-width'>
                    <LabelSwitch
                        checked={EnableQuota}
                        onChange={this.changeEnableQuota}
                        label={$t('sto.Quata')}
                        colWidth={getGrid(multiple).colWidth}/>
                </Row>
                <Row className='padding14'>
                    <Alert message={$t('sto.QuotaSettingTip')} type="warning" />
                </Row>
                {EnableQuota &&
                <Row className='quota-dlg-row-width'>
                    <Col {...getGrid(multiple2).label} style={{marginTop:'12px'}}>
                        <label>{$t('sto.QuotaSetup')}</label>
                    </Col>
                    <Col span = {15}>
                        <Slidertool
                            $t = {$t}
                            value = {videoPercent}
                            doChange = {this.changeVideoPercent}
                        />
                    </Col>
                </Row>}
            </Modal>
        );
    }
}

class FormatMemoryCard extends Component {
    constructor (props) {
        super(props);
        this.state = {
            isReboot: true, //格式化硬盘后是否需要重启
            SupportModeQuota: false,//磁盘支持的工作模式是否包含Quota配额
            selectedRowIndex: [], //选中的分区序号
            selectedRowKeys:[], //选中的设备序号
            selectedRows: [], //选中的设备
            drawerShow:false,
            loading:false,
            needRebootAfterFormat: 1,
            visibleEncryptModal: false, // 显示隐藏加密的弹出框
            visibleDecryptModal: false, // 显示隐藏认证的弹出框
            visibleClearPasswordModal: false, // 显示隐藏清除密码的弹出框
            visibleModifyPasswordModal: false, // 显示修改密码的弹出框
            visibleQuotaInfoModal: false,//显示配额设置弹出框
            EnableQuota: false,//配额设置的开启状态，用于向弹出框传值
            videoPercent: 0,//配额设置录像的百分比，用于向弹出框传值
            supportEncrypt: false, // 显示隐藏加密，认证，修改密码，删除密码的容器
            disabledEncrypt: true, // 禁用加密按钮
            disabledDecrypt: true, // 禁用认证按钮
            disabledModPwd: true, // 禁用改密码
            disabledDelPwd: true, // 禁用清除密码
            showFileSystem: {
                SupportDisplayFS: 0, //1
                SupportDisplaySpeedClass: 0, //2
                title: ['com.FileSystem', 'com.Level'], //为了实时翻译, 故从 content 抽离
                content: [
                    { // 文件系统--注意有翻译
                        // title: 'com.FileSystem',
                        key: 'FileSystem',
                        render: (text, record, index) => {
                            if(record.FsType === 'PrivateFS') {
                                return props.$t('sys.PrivateFileSystem');
                            }
                            return record.FsType;
                        }
                    },
                    { // 等级
                        // title: 'com.Level',
                        key: 'Level',
                        render: (text, record, index) => {
                            // UHSSpeedGrade = 'U1', 'U2', 不支持时为 ''; --有返回 U1字样时，优先显示这个
                            if(record.UHSSpeedGrade && record.UHSSpeedGrade[index] === 'U') return record.UHSSpeedGrade;
                            return record.SpeedClass;
                        }
                    },
                ],
                reflect (type, {$t, SupportDisplayFS, SupportDisplaySpeedClass}) {
                    // 期望模式--1, 获取表格 column数据; 2, 更新 能力控制
                    if(type === 'getContent') { //获取 表格column数据--文件系统,等级
                        const result = this.SupportDisplayFS + this.SupportDisplaySpeedClass;
                        const that = this;
                        switch(result) { //文件系统显示，等级显示，两个都显示
                        case 1:
                            return [
                                Object.assign({title: $t(this.title[0])}, this.content[0])
                            ];
                        case 2:
                            return [
                                Object.assign({title: $t(this.title[1])}, this.content[1])
                            ];
                        case 3:
                            return this.title.map((item, idx) => Object.assign({title: $t(item)}, that.content[idx]));
                        default:
                            return [];
                        }
                    } else if(type === 'update') { // 传入 pd对应配置 初始化能力值
                        const data = {};
                        if(SupportDisplayFS === true) data.SupportDisplayFS = 1;
                        if(SupportDisplaySpeedClass === true) data.SupportDisplaySpeedClass = 2;
                        return Object.assign(this, data);
                    }
                }
            }
        };
    }

    componentDidMount () {
        const {getDeviceAllInfo, getQuotaInfo} = this.props;
        getDeviceAllInfo();
        getQuotaInfo();
        Ability.is('RemoteStoreList').then(json => {
            this.setState({
                needRebootAfterFormat: json.NeedRebootAfterFormat
            });
        });
        Ability.get('PD').then(pd => {
            if(pd.SDcardDisplay) {
                this.setState({
                    showFileSystem: this.state.showFileSystem.reflect('update', pd.SDcardDisplay)
                });
            }
        });
        let self = this;
        RPC.Storage.getCaps().then(json => {
            //格式化硬盘后是否需要重启
            // 0-未知(兼容老设备，处理策略推荐SD卡重启，其它不重启)
            // 1-不需要重启
            // 2-需要重启，如果使用二代协议格式化，会自动执行重启，使用三代协议格式化，需要客户端发起重启
            if (json && json.caps) {
                if (json.caps.NeedRebootAfterFormat === 1) {
                    self.setRebootFlag(false);
                }
                //是否支持配额
                if (json.caps.SupportMode && json.caps.SupportMode.indexOf('Quota') > -1) {
                    this.setState({
                        SupportModeQuota: true
                    });
                }
            }
        });
    }
    setRebootFlag = (flag) => {
        this.setState({
            isReboot: flag
        });
    }
    // 格式化SD
    formatPatition = () => {
        let {$t, deviceList, formatDevStorage} = this.props;
        let params, params1;

        let {selectedRowKeys} = this.state;
        if (!selectedRowKeys.length) return;
        params = deviceList[selectedRowKeys[0]] && deviceList[selectedRowKeys[0]].Name || '';

        if ( WebApp.GongAnDetect && selectedRowKeys.length > 1) {
            params1 = deviceList[1] && deviceList[1].Name || '';
        }
        let contentTip = 'com.CfmFormatRebootTip';
        Ability.get('PartSolution').then(res => {
            if (res && res.Distribution) {
                let arr = res.Distribution;
                for (let item in arr) {
                    if (item.FileSystem === 'DHFS') {
                        contentTip = 'sto.CfmFormat2PartitionTip';
                    }
                }
            }
        });
        Modal.confirm({
            centered: true,
            title: $t('sto.FormatSD'),
            content: $t(contentTip),
            onOk: () => {
                if (WebApp.GongAnDetect && selectedRowKeys.length > 1) {
                    this.formatMyDeviceStorage(params).then(this.formatMyDeviceStorage(params1));
                }else {
                    this.formatMyDeviceStorage(params);
                }
            }
        });
    }
    formatMyDeviceStorage = (name) => {
        let {$t, getDeviceAllInfo, webCaps} = this.props;
        let {isReboot,selectedRows} = this.state;
        return RPC.getDeviceInfo('getDeviceInfo', name).then((json) => {
            let params = {
                name: name,
                part: name,
                fs: json.device.Partitions[selectedRows[0].detailKey || 0].FileSystem
            };
            RPC.formatPatition('formatPatition', params).then((json2) => {
                message.success($t('com.Operateingsuccess'));
                getDeviceAllInfo();
                if (!webCaps.is_noNeed_reboot && isReboot) {
                    //弹出确认框，是否重启，确认之后，提示：格式化成功，设备正在重启，请稍后重新连接……
                    WebApp.reboot('com.FormatSDRestartDevice', false, $t, Modal);
                }
            }).catch((err) => {
                console.log(err);
            });
        }).catch(() => {
            message.error($t('com.Operateingfailure'));
        }).finally(() => {
            // dispatch(updateDeviceList([...deviceList]));
        });
    }
    // 设置只读
    setReadOnlyClick = () => {
        let {setGroupInfo} = this.props;
        let {selectedRowKeys} = this.state;
        let params = {
            group:{
                'group': 'ReadOnly'
            },
            name: {
                'name': this.state.selectedRows[0].Path || '/mnt/sd'
            }
        };
        setGroupInfo(params);
        if (WebApp.GongAnDetect && selectedRowKeys.length > 1) {
            let params1 = {
                group:{
                    'group': 'ReadOnly'
                },
                name: {
                    'name': this.state.selectedRows[1].Path || '/mnt/sd'
                }
            };
            setGroupInfo(params1);
        }
    }
    // 设置读写
    setReadWriteClick = () => {
        let {setGroupInfo} = this.props;
        let {selectedRowKeys} = this.state;
        let params = {
            group:{
                'group': 'ReadWrite'
            },
            name: {
                'name': this.state.selectedRows[0].Path || '/mnt/sd'
            }
        };
        setGroupInfo(params);
        if (WebApp.GongAnDetect && selectedRowKeys.length > 1) {
            let params1 = {
                group:{
                    'group': 'ReadWrite'
                },
                name: {
                    'name': this.state.selectedRows[1].Path || '/mnt/sd'
                }
            };
            setGroupInfo(params1);
        }
    }
    //设置热插拔
    setHotSwapClick = () => {
        let {setEject, deviceList} = this.props;
        let {selectedRowKeys} = this.state;
        let params = deviceList[selectedRowKeys[0]] && deviceList[selectedRowKeys[0]].Name || '';
        setEject(params);
        if (WebApp.GongAnDetect && selectedRowKeys.length > 1) {
            let params1 = deviceList[1] && deviceList[1].Name || '';
            setEject(params1);
        }
    }
    //配额设置弹出框
    showDlgQuotaInfo = () => {
        let {selectedRowKeys, SupportModeQuota , selectedRows} = this.state;
        let {deviceList, $t} = this.props;
        if (!selectedRowKeys.length) return;
        if (selectedRowKeys.length > 1) {
            message.warning($t('ivs.FaceFaceLibOnlyOne'));
            return;
        }
        let SupportQuota = deviceList[selectedRowKeys[0]] && deviceList[selectedRowKeys[0]].SupportQuota;//选中的SD卡是否支持配额设置
        //提示格式化
        if (!SupportQuota) {
            message.warning($t('sto.BeginQuotaTip'));
            return;
        }
        //目前只支持一个sd卡的硬盘配额
        this.setState({
            EnableQuota: selectedRows[0].EnableQuota,
            videoPercent: selectedRows[0].videoPercent,
            visibleQuotaInfoModal: true
        });
    }
    onRefresh = () => {
        let {getDeviceAllInfo, getQuotaInfo} = this.props;
        getDeviceAllInfo(true);
        getQuotaInfo();
    }
    // 勾选
    onSelectChange (selectedRowIndex, selectedRows) {

        let {deviceList} = this.props;
        const selectedRowKeys = selectedRows.map((item) => item.key);
        this.setState({
            selectedRowIndex, // 选中的Detail分区序号
            selectedRowKeys:selectedRowKeys, // 外层选中的设备的序号值
            selectedRows:selectedRows
        });

        if (WebApp.GongAnDetect && selectedRows.length > 1) {
            if (this.state.supportEncrypt) {
                this.setState({supportEncrypt: false});
            }
            return;
        }
        // 当前选中了元素，且标志为1,则显示加密等按钮
        if (selectedRows.length && deviceList[selectedRowKeys[0]].SDEncryptFlag === 1) {
            this.setState({
                supportEncrypt: true
            });
        } else {
            this.setState({
                supportEncrypt: false
            });
        }
    }

    // 获取加密等按钮的禁用状态
    getBtnDisabled () {
        // 处理加密等按钮的禁用状态
        var { deviceList } = this.props;
        let {selectedRowKeys} = this.state;
        var result = {};

        // 能被选中，则一定有数据
        var lockState = deviceList && deviceList[selectedRowKeys[0]] && deviceList[selectedRowKeys[0]].LockState;
        // state = 0，禁用认证，修改密码, 删除密码
        if (lockState === 0) {
            result = {
                disabledEncrypt: false, // 加密按钮
                disabledDecrypt: true, // 认证按钮
                disabledModPwd: true, // 改密码
                disabledDelPwd: true // 清除密码
            };
        } else if (lockState === 1) {
            // state = 1,禁用加密
            result = {
                disabledEncrypt: true, // 加密按钮
                disabledDecrypt: false, // 认证按钮
                disabledModPwd: false, // 改密码
                disabledDelPwd: false // 清除密码
            };
        } else if (lockState === 2) {
            // state = 2,禁用加密,认证
            result = {
                disabledEncrypt: true, // 加密按钮
                disabledDecrypt: true, // 认证按钮
                disabledModPwd: false, // 改密码
                disabledDelPwd: false // 清除密码
            };
        }

        return result;
    }

    // 点击加密认证那几个按钮
    clickEncryptBtns (type) {
        var modalKeyMap = {
            Encrypt: 'visibleEncryptModal', // 加密
            Decrypt: 'visibleDecryptModal', // 认证
            ModifyPassword: 'visibleModifyPasswordModal', // 修改密码
            ClearPassword: 'visibleClearPasswordModal' // 清除密码
        };

        this.setState({
            [modalKeyMap[type]]: true
        });
    }

    // 加密弹出框的提交操作
    onConfirmEncryptModal (password) {

        var { deviceList, encrypt } = this.props;
        let {selectedRowKeys} = this.state;
        if(!selectedRowKeys.length) return;
        encrypt({
            name: deviceList[selectedRowKeys[0]].Name,
            password
        });

        this.setState({
            visibleEncryptModal: false
        });
    }

    // 加密弹出框的关闭操作
    onCancelEncryptModal () {
        this.setState({
            visibleEncryptModal: false
        });
    }

    // 清除密码弹出框的确认操作
    onConfirmClearPasswordModel (password) {
        var { deviceList, clearPassword } = this.props;
        let {selectedRowKeys} = this.state;
        if(!selectedRowKeys.length) return;
        // rpc请求
        clearPassword({
            name: deviceList[selectedRowKeys[0]].Name,
            password
        });

        // 隐藏弹出框内容
        this.setState({
            visibleClearPasswordModal: false
        });
    }

    // 关闭清除密码的弹出框
    onCancelClearPasswordModel () {
        this.setState({
            visibleClearPasswordModal: false
        });
    }

    // 修改密码的确认操作
    onConfirmModifyPasswordModel (json) {

        var { deviceList, modifyPassword } = this.props;
        var {oldPassword, password } = json;
        let {selectedRowKeys} = this.state;
        if(!selectedRowKeys.length) return;
        // RPC请求
        modifyPassword({
            name: deviceList[selectedRowKeys[0]].Name, // 基线设计，只设计了存在一张卡的场景，目前都不支持多卡
            password,
            oldPassword
        });

        // 隐藏弹出框内容
        this.setState({
            visibleModifyPasswordModal: false
        });
    }

    // 关闭修改密码的弹出框
    onCancelModifyPasswordModel () {
        this.setState({
            visibleModifyPasswordModal: false
        });
    }

    //修改硬盘配额的确认操作
    onConfirmQuotaInfoModel (obj) {
        // 隐藏弹出框内容
        this.setState({
            visibleQuotaInfoModal: false
        });
        //obj.videoPercent,obj.EnableQuota
        let {selectedRowIndex} = this.state;
        let {quotaInfoList, setQuotaInfo} = this.props;
        quotaInfoList[selectedRowIndex[0]].Enable = obj.EnableQuota;
        quotaInfoList[selectedRowIndex[0]].Image.Percent = 100 - obj.videoPercent;
        quotaInfoList[selectedRowIndex[0]].Video.Percent = obj.videoPercent;
        setQuotaInfo({
            CapacityFileType: [...quotaInfoList]
        });
    }

    //取消修改硬盘配额的操作
    onCancelQuotaInfoModel () {
        // 隐藏弹出框内容
        this.setState({
            visibleQuotaInfoModal: false
        });
    }

    //修改硬盘配额百分比
    onChangeVideoPercent (val) {
        this.setState({
            videoPercent: val
        });
    }

    //修改硬盘配额使能
    onChangeEnableQuota (val) {
        this.setState({
            EnableQuota: val
        });
    }

    // 点击认证密码弹出的确认框
    onConfirmDecryptModal (password) {
        var { deviceList, decrypt } = this.props;
        let {selectedRowKeys} = this.state;
        if(!selectedRowKeys.length) return;
        // 只有当前密码存在时，才进行其他操作
        if (password) {
            // RPC请求
            decrypt({
                name: deviceList[selectedRowKeys[0]].Name, // 基线设计，只设计了存在一张卡的场景，目前都不支持多卡
                password: password
            });
        }
        this.setState({
            visibleDecryptModal: false
        });
    }

    // 关闭认证密码的弹出框
    onCancelDecryptModal () {
        this.setState({
            visibleDecryptModal: false
        });
    }

    // changeDrawStatus = () => {
    //     this.setState(({drawerShow}) => ({
    //         drawerShow:!drawerShow
    //     }) );
    // }

    render () {
        let {$t, smart, isNav, height, deviceList, quotaInfoList} = this.props;

        // 加密，认证等按钮disable与显示的能力
        let { supportEncrypt, visibleEncryptModal, visibleDecryptModal, visibleQuotaInfoModal, visibleClearPasswordModal, visibleModifyPasswordModal, SupportModeQuota } = this.state;

        let { disabledEncrypt, disabledDecrypt, disabledModPwd, disabledDelPwd } = this.getBtnDisabled();

        let listData = new ListData(deviceList).get();
        let column = []; // 保存表头信息

        // 名称，状态，属性
        column.push({title:$t('com.Name'),key:'Name'}, {title:$t('com.Status'),key:'State'}, {title:$t('ivs.Attributeset'), key: 'Type'});

        // 目前设备设定只支持1张卡，如果支持多张的话，目前基线设定有bug
        // 是否支持显示模式
        let isShowMode = listData.some(item => 'LockState' in item && item.SDEncryptFlag);
        if (isShowMode) {
            column.push({title:$t('com.Mode'), key:'Mode'});
        }
        // 添加使用情况
        column.push({title:$t('sto.CapaUsed') + '/' + $t('sto.TotalCapacity'),key:'Capacity'});

        // 是否显示健康信息，目前代码都是建立在只有一张卡的情况，如果多张，就异常了
        let isShowHealthInfo = null;
        // 放开多张
        // if (!WebApp.GongAnDetect) {
        //     isShowHealthInfo = listData && listData[0] && !!listData[0].HealthDataFlag;
        // }else {
        //     isShowHealthInfo = listData.some(item => item.HealthDataFlag);
        // }
        isShowHealthInfo = listData.some(item => item.HealthDataFlag);
        if (isShowHealthInfo) {
            column.push({title: $t('ivs.healthInfo'), key: 'Health'});
        }

        var lockStateArr = [$t('com.General'), $t('net.UnAuthorised'), $t('com.Authentication')];
        // let columnWithScroll = [
        //     {title:$t('com.Name'),key:'Name',width:100},
        //     {title:$t('sto.Physicalposition'),key:'Partitions',width:100},
        //     {title:$t('com.Type'),key:'BUS',width:150},
        //     {title:$t('com.Status'),key:'State',width:100},
        //     {title:$t('sto.LevelofSDardarea') + '/' + $t('sto.TotalCapacity'),key:'Capacity'}
        // ];
        // let columnOfDrawer = [
        //     {title:$t('com.Numbers'),key:'Name'},
        //     {title:$t('net.Explain'),key:'Position'},
        //     {title:$t('com.NumberValue'),key:'Volume'},
        //     {title:$t('com.DiffValue'),key:'State'},
        //     {title:$t('com.Bound'),key:'Capacity'},
        //     {title:$t('com.OriginalVal'),key:'Capacity'},
        //     {title:$t('com.Status'),key:'Capaci'}
        // ];

        if (!deviceList) deviceList = [];

        const tranLate = (num) => {
            return Math.round( num / Math.pow(1024,3) * 100 ) / 100 + 'GB';
        };
        const format = (left,total) => {
            return () => {
                return (<span>{tranLate(left)} / {tranLate(total)}</span>);
            };
        };
        const format2 = (userd,total) => {
            return (userd * 100 / total).toFixed(2) - 0;
        };
        let device = [];
        // if (!WebApp.GongAnDetect) {
        //     device = listData = listData[0] && listData[0].Detail || [];
        // }else {
        //     device = listData && listData.map(item => {
        //         item.Detail[0].HealthDataFlag = item.HealthDataFlag;
        //         return item.Detail[0];
        //     });
        // }
        listData && listData.map((item, deviceIndex) => {
            // Detai为分区信息
            item.Detail.forEach((deviceDetail, detailIndex) => {
                deviceDetail.HealthDataFlag = item.HealthDataFlag;
                // 设备序号
                deviceDetail.key = deviceIndex;
                deviceDetail.detailKey = detailIndex; //分区序号
                device.push(deviceDetail);
            });
        });
        // 设备内Detail分区的所有信息
        device && device.map((item, index) => {
            return item.detailIndex = index;
        });
        //是否显示配额状态列
        if (SupportModeQuota) {
            column.push({title: $t('sto.QuotaStatus'), key: 'quotaStatus'});
            //配额状态初始化为未配额
            device && device.map((item, index) => {
                return item.quotaStatus = $t('com.Disabled');
            });
        }
        //更新配额状态
        SupportModeQuota && device && quotaInfoList && device.length === quotaInfoList.length && quotaInfoList.map((item, index) => {
            device[index].EnableQuota = item.Enable;
            device[index].videoPercent = item.Video.Percent;
            return device[index].quotaStatus = item.Enable ? $t('com.Enabled') : $t('com.Disabled');
        });
        // let columns = new ColumnHeader(isNav ? columnWithScroll : column);
        let columns = new ColumnHeader(column);
        // if (smart) {
        //     columns.addOtherColumn('Smart',() => ( <Button onClick = {this.changeDrawStatus}>S.M.A.R.T</Button>),'S.M.A.R.T');
        // }
        columns.addOtherColumn('Name',(State, record) => {
            return $t('sys.LocalDisk') + (record.key + 1);
        });
        // columns.addOtherColumn('Partitions',(Partitions) => {
        //     var text = Partitions && Partitions[0] && Partitions[0].MountOn;
        //     return text;
        // });
        columns.addOtherColumn('State',(State, record) => {
            return record.IsFsChecking && WebApp.GongAnDetect ? $t('com.DiskCheck') : record.IsError ? $t('com.Stateunormal') : $t('com.Normal');
        });

        columns.addOtherColumn('Capacity',(text,record) =>
            (<Progress
                style={{width:'50%'}}
                format={format(record.UsedBytes,record.TotalBytes)}
                percent={format2(record.UsedBytes, record.TotalBytes)}>
            </Progress>
            )
        );

        // 模式显示内容
        //搜索协议 storage.getDeviceAllInfo; listData 等于其中Detail对象，deviceList 大概为整个 info 对象
        if (isShowMode) {
            columns.addOtherColumn('Mode', (mode, record, index) => {
                index = record.key;
                if (WebApp.GongAnDetect && !record.HealthDataFlag) return false;
                return lockStateArr[deviceList[index] && deviceList[index].LockState];
            });
        }

        // 健康状态内容显示
        isShowHealthInfo && columns.addOtherColumn('Health', (info, record, index) => {
            index = record.key;
            var lifeState = ''; // 状态进度样式展示
            var transStr = ''; //翻译内容展示
            // var lifePercent = deviceList[0] && deviceList[0].LifePercent;
            var lifePercent = deviceList[index] && (100 - deviceList[index].LifePercent);
            var colorArr = ['#52c41a', '#1890ff', '#ffc669', '#ff4d4f'];
            var color = 'transparent';
            if(lifePercent >= 70) {
                color = colorArr[0];
                transStr = 'com.Excellent'; // 优
            }else if(lifePercent >= 50) {
                color = colorArr[1];
                transStr = 'com.GoodMinus'; // 良
            }else if(lifePercent >= 20) {
                color = colorArr[2];
                transStr = 'com.Middle'; // 中
            }else{
                color = colorArr[3];
                transStr = 'com.Bad'; // 差
            }
            console.log(lifePercent);
            //使用后strokeColor为纯色，再加一个从 ant d中找出来的背景渐变，跟用statuc的一样
            color += ' linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)';
            if (WebApp.GongAnDetect && !record.HealthDataFlag) return false;
            return(<Tooltip title={$t(transStr)}>
                <Progress
                    // status = 'success'
                    strokeColor = {color}
                    style={{width:'50%'}}
                    showInfo = {false}
                    percent={lifePercent}>
                </Progress>
            </Tooltip>);
        });

        // 属性设置，读写类型
        columns.addOtherColumn('Type', (type, record) => {
            if (record.Type === 'ReadWrite') {
                return $t('sto.TypeW');
            } else {
                return $t('sto.ReadOnly');
            }
        });

        let columnsData = columns.get();

        const nextColumn = this.state.showFileSystem.reflect('getContent', {$t});
        columnsData.push(...nextColumn);

        const rowSelection = {
            type: WebApp.GongAnDetect ? 'checkbox' : 'radio',
            selectedRowKeys:this.state.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => this.onSelectChange(selectedRowKeys, selectedRows),
        };
        // const drawerParams = {
        //     title:'S.M.A.R.T',
        //     width:'700px',
        //     visible: this.state.drawerShow,
        //     onClose:this.changeDrawStatus,
        //     render:(
        //         <Table
        //             columns={columnOfDrawer}
        //             noBoderTop = {true}
        //             noBoderLR = {true}
        //         />
        //     )
        // };
        const antPagination = {
            position:'bottom',
            hideOnSinglePage:true
        };
        let buttonDisabled = !this.state.selectedRowKeys.length || !deviceList.length;
        // 热插拔是否有效
        let CantHotPlug = buttonDisabled || (deviceList[this.state.selectedRowKeys[0]] && deviceList[this.state.selectedRowKeys[0]].CantHotPlug);
        return (
            <React.Fragment>
                <Button style= {{marginBottom:'25px'}} disabled={buttonDisabled} onClick={this.formatPatition}>
                    {$t('com.Format')}
                </Button>
                <Button style= {{marginBottom:'25px', marginLeft: '10px'}} disabled={buttonDisabled} onClick={this.setReadOnlyClick}>
                    {$t('sys.ReadOnly')}
                </Button>
                <Button style= {{marginBottom:'25px', marginLeft: '10px'}} disabled={buttonDisabled} onClick={this.setReadWriteClick}>
                    {$t('sys.ReadWrite')}
                </Button>
                <Button style= {{marginBottom:'25px', marginLeft: '10px'}} disabled={CantHotPlug} onClick={this.setHotSwapClick}>
                    {$t('com.HotPullInsert')}
                </Button>
                {
                    SupportModeQuota &&
                    <Button style= {{marginBottom:'25px', marginLeft: '10px'}} disabled={buttonDisabled} onClick={this.showDlgQuotaInfo}>
                        {$t('sto.Setscal')}
                    </Button>
                }
                <Button style= {{marginBottom:'25px', marginLeft: '10px'}} disabled={false} onClick={this.onRefresh}>
                    {$t('com.Refresh')}
                </Button>

                {
                    supportEncrypt && <div>
                        <Button style= {{marginBottom:'25px'}} disabled={disabledEncrypt} onClick={this.clickEncryptBtns.bind(this, 'Encrypt')}>
                            {$t('SDEncrypt.Encrypt')}
                        </Button>
                        <Button style= {{marginBottom:'25px', marginLeft: '10px'}} disabled={disabledDecrypt} onClick={this.clickEncryptBtns.bind(this, 'Decrypt')}>
                            {$t('SDEncrypt.Decrypt')}
                        </Button>
                        <Button style= {{marginBottom:'25px', marginLeft: '10px'}} disabled={disabledModPwd} onClick={this.clickEncryptBtns.bind(this, 'ModifyPassword')}>
                            {$t('sys.ModifyPwd')}
                        </Button>
                        <Button style= {{marginBottom:'25px', marginLeft: '10px'}} disabled={disabledDelPwd} onClick={this.clickEncryptBtns.bind(this, 'ClearPassword')}>
                            {$t('SDEncrypt.ClearPassword')}
                        </Button>
                    </div>
                }
                <Table
                    rowKey={record => record.detailIndex}
                    antPagination = {antPagination}
                    height = {!isNav ? '' : height}
                    dataSource={device}
                    columns={columnsData}
                    rowSelection={rowSelection}
                    pagination = {false}
                />

                <EncryptModal
                    $t = {$t}
                    onConfirm = {this.onConfirmEncryptModal.bind(this)}
                    onCancel = {this.onCancelEncryptModal.bind(this)}
                    visible = {visibleEncryptModal}/>

                <DecryptModal
                    $t = {$t}
                    onConfirm = {this.onConfirmDecryptModal.bind(this)}
                    onCancel = {this.onCancelDecryptModal.bind(this)}
                    visible = {visibleDecryptModal}/>

                <ClearPasswordModel
                    $t = {$t}
                    onConfirm = {this.onConfirmClearPasswordModel.bind(this)}
                    onCancel = {this.onCancelClearPasswordModel.bind(this)}
                    visible = {visibleClearPasswordModal}/>

                <ModifyPasswordModel
                    $t = {$t}
                    onConfirm = {this.onConfirmModifyPasswordModel.bind(this)}
                    onCancel = {this.onCancelModifyPasswordModel.bind(this)}
                    visible = {visibleModifyPasswordModal}/>
                {
                    SupportModeQuota &&
                    <ShowQuotaInfoModal
                        $t = {$t}
                        EnableQuota = {this.state.EnableQuota}
                        videoPercent = {this.state.videoPercent}
                        publicState = {this.props.publicState}
                        onChangeVideoPercent = {this.onChangeVideoPercent.bind(this)}
                        onChangeEnableQuota = {this.onChangeEnableQuota.bind(this)}
                        onConfirm = {this.onConfirmQuotaInfoModel.bind(this)}
                        onCancel = {this.onCancelQuotaInfoModel.bind(this)}
                        visible = {visibleQuotaInfoModal}/>
                }
            </React.Fragment>
        );
    }
}
const FormatMemory = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(LangConsumer(FormatMemoryCard));
export default FormatMemory;
